import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
    lang: {},
    language: 'en'
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    setDocumentTitle(`Privacy Policy`)
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken
    })
    
  }

  componentDidMount() {
  }

  jump = () => {
    history.push(`/activity/lottery?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  jumpChild = () => {
    history.push(`/app/child_safety_policy?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  render() {
    return (
      <div className="policy">
        <h1>Privacy Policy</h1>
Last Updated: 2025/08/15<br/>
Effective Date: 2025/08/05<br/>
At Yayya, we fully understand the importance of your privacy and are committed to providing you with a secure and private experience.<br/>
Ensuring the security and protection of user data is our top priority. This Privacy Policy outlines the data we collect when you access and use our products and services, and how it is processed.<br/>
Before using or continuing to use our products and services, please read and fully understand this policy, and make appropriate choices as guided.<br/>
If you do not agree with the contents of this policy, it may result in our products or services not functioning properly or failing to meet expectations.<br/>
You should immediately stop accessing or using our products and services. Your continued use signifies that you fully understand and agree to the contents of the Yayya Privacy Policy.<br/>

1. About Us<br/>
This full policy (including updated versions) sets out the basis on which we process any personal data collected from you or provided by you.<br/>
If you have any questions about how we use your personal data, please contact us at xxxx.<br/>
This Privacy Policy helps you understand the following:<br/>
1. How we collect and use your personal information;<br/>
2. How we store and protect your personal information;<br/>
3. How we share, transfer, and disclose your personal information;<br/>
4. How to delete your account;<br/>
5. CSAE commitments and related policies;<br/>
6. How to contact us.<br/>

1. How We Collect and Use Your Personal Information<br/>
We collect and use your personal information based on principles of legitimacy, lawfulness, and necessity.<br/>
This includes information you voluntarily provide while using our services, or information generated during use of our products and/or services.<br/>
We will use such information only for the purposes specified in this policy.<br/>
If we intend to use your personal information for any purpose not stated in this policy, or use collected data for other specific purposes, we will notify you reasonably and obtain your consent again before doing so.<br/>
We will also control access frequency within a reasonable range.<br/>

1.1 Summary of Device Permission Usage<br/>
In providing services, we may request access to certain device permissions.<br/>
You can disable some or all permissions in your device settings.<br/>
Permission display and disabling may vary across devices.<br/>

<table border="1">
  <tr>
    <th>Device Permission</th>
    <th>Permission Attribute</th>
    <th>Service Function</th>
    <th>Can be disabled</th>
  </tr>
  <tr>
    <td>Network Services</td>
    <td> Core service function</td>
    <td>Read and update app content</td>
    <td>Yes. If disabled, app content cannot be read or updated in real time, and the app may not function properly.</td>
  </tr>
  <tr>
    <td>Microphone</td>
    <td>Core service functions</td>
    <td>Voice call</td>
    <td>Yes. Closing it will only affect the corresponding function, and will not affect other application functions</td>
  </tr>
  <tr>
    <td>Media file storage</td>
    <td>Core service functions</td>
    <td>Information cache</td>
    <td>Yes. After closing, it only affects the corresponding functionsand will not affect other application functions</td>
  </tr>
  <tr>
    <td>Album permissions</td>
    <td>Core service functions</td>
    <td>Information cache</td>
    <td>Yes. After closing, it only affects the corresponding functionsand will not affect other application functions</td>
  </tr>
</table>

{/* - Device Permission: Network Services<br/>
- Permission Attribute: Core service function<br/>
- Service Function: Read and update app content<br/>
- Can be disabled: Yes. If disabled, app content cannot be read or updated in real time, and the app may not function properly.<br/> */}

2. Registration and Login<br/>
2.1 When you register or log in with your mobile number, we collect your [mobile number and carrier information] to provide a convenient login service.<br/>
2.2 You may choose to provide or modify your information as needed. Not providing such information will not affect your use of the product and related services (except for username, which is required during registration).<br/>
2.3 Once you successfully register a Yayya account, your personal information will be displayed in the app.<br/>
When you use platform services, we will automatically collect your data, including Open ID, IP address, device ID, device series ID, Android ID, XID (generated based on existing device info, model, manufacturer, Android ID, and timezone), registration time, login time, and your service usage records, such as operation date and timestamp.<br/>

2. How We Store and Protect Your Personal Information<br/>
We strictly comply with data protection laws and regulations in your country, and ensure that data recipients have sufficient capabilities to protect your personal data.<br/>
Retention period:<br/>
We are committed to storing your personal information only for the period required by applicable laws and regulations.<br/>
Once this period has passed, we will delete or anonymize your personal information.<br/>
(Anonymization refers to processing personal data so the subject can no longer be identified, and the data cannot be reversed. Anonymized data is no longer considered personal information.)<br/>
If we cease operations, we will immediately stop collecting your personal information, notify you via individual services or announcements, and delete or anonymize all personal data we hold.<br/>

3. How We Share, Transfer, and Disclose Your Personal Information<br/>
We do not share your personal information with any company, organization, or individual unless one or more of the following conditions apply:<br/>
(1) We have obtained your prior consent;<br/>
(2) You have personally requested it.<br/>
(3) Third-Party SDK Providers We Collaborate With:
<br/>When you use features provided by third parties in Yayya, we may integrate software development kits (SDKs) from these third-party providers to enable the relevant functionalities. We enter into cooperation agreements to regulate the behavior of these SDK providers. However, third-party SDK providers may collect your personal information. The collection and processing of your information by these service providers are governed by their respective privacy policies, which are not covered by this policy.

<br/>To maximize the protection of your personal information, we recommend that you review the privacy policy of any third-party SDK before using its services. To protect your legal rights, if you discover that any SDK or similar application poses potential risks, we advise you to stop using the relevant services immediately and contact us promptly.

<br/>Please refer to the following section for detailed information on the collection and use of information by third-party SDKs.
<br/><table border="1">
  <tr>
    <th>SDK</th>

      <th>service provider</th>
    <th>purpose</th>

<th>Collected information</th><th>Privacy Policy</th>
  </tr>
  <tr>
    <td>Instant messaging (IM)</td>
    <td>Huanxin</td>

<td>User private chat message communication</td><td>Read and update app content</td>
    <td>https://www.easemob.com/protocol</td>
  </tr>
  <tr>
    <td>Voice Network</td>
    <td>Voice Network</td>

<td>voice call</td><td>Network type, user's local IP address, WIFI and cellular network signal status, operating system, device model, CPU, memory, device battery level, audio stream data, Bluetooth, network latency, packet loss rate, bit rate, resolution, audio bit rate, sampling rate</td>
    <td>https://www.agora.io/cn/privacy-policy</td>
  </tr>

</table>
<br/>
4. How to Delete Your Account<br/>
You may delete your account within the app by going to Settings > Account > Linked Accounts > Delete Account.<br/>
Once the account is deleted, your personal data will be removed from Yayya, except for information that must be retained by law (e.g., data required by government or legal regulations).<br/>

5. CSAE Commitments and Related Policies<br/>
We are committed to preventing child abuse and exploitation and strictly comply with all relevant laws and standards.<br/>
You can view our policy details at the following link: [Link to the statement page or related resource]<br/>

6. Contact Us<br/>
If you have any questions or suggestions about our privacy policy, please contact us via:<br/>
steven1082025@outlook.com<br/>

Statement: We may update this Privacy Policy based on legal changes or feature updates.<br/>
Any changes will be published on this page in a timely manner. Please check back regularly to stay informed.<br/>
 </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/privacypolicy_ios/index.js